import type { ReactNode } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface DashboardShellProps {
  children: ReactNode;
}

export function DashboardShell({ children }: DashboardShellProps) {
  return (
    <div className="dash-shell">
      <Header />
      <div className="dash-shell__body">
        <Sidebar />
        <main className="dash-shell__content">{children}</main>
      </div>
    </div>
  );
}
